import classnames from 'classnames';
import React, {Component} from 'react';
import './Combo.css';

class Combo extends Component {
  render() {
    const { open, label, onClick, className } = this.props;
    return (
      <div className={classnames('combo ', { open: open }, className)} onClick={onClick}>
        <div className="toggle">
          <label>{label}</label>
          <i className="fa fa-chevron-down"/>
        </div>
        <div className="contents-container">
          <div className="contents">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default Combo;



// WEBPACK FOOTER //
// ./src/components/Combo.js